import { useMemo } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

export const AgentSuccessPage = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const summary = useMemo(() => {
    const os = searchParams.get('os')?.toUpperCase() ?? 'WINDOWS'
    const arch = searchParams.get('arch')?.toUpperCase() ?? 'X64'
    return `${os} · ${arch}`
  }, [searchParams])

  return (
    <div className="min-h-screen bg-[#f8f9fb] flex flex-col items-center justify-center px-4 py-12">
      <div className="mb-10 flex flex-col items-center gap-3">
        <img src="/black_logo.svg" alt="Helpdesk 411" className="h-12 w-auto" />
        <div className="flex items-center gap-1 text-sm text-gray-500">
          <span className="inline-flex h-2 w-2 rounded-full bg-gray-300" />
          <span className="inline-flex h-2 w-2 rounded-full bg-gray-300" />
          <span className="inline-flex h-2 w-2 rounded-full bg-red-500" />
        </div>
      </div>

      <div className="w-full max-w-xl rounded-3xl bg-white p-12 shadow-sm border border-gray-100 text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-green-100 text-green-600">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 className="text-2xl font-semibold text-gray-900">Agent Installed Successfully</h1>
        <p className="mt-3 text-sm text-gray-600">
          Great! Your device is now connected to Helpdesk 411 ({summary}). You can close this window and start reporting issues or continue exploring the app.
        </p>

        <div className="mt-8 flex flex-col gap-3">
          <button
            type="button"
            onClick={() => navigate('/dashboard')}
            className="inline-flex items-center justify-center rounded-full bg-gray-900 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-gray-800"
          >
            Go to Dashboard
          </button>
          <button
            type="button"
            onClick={() => navigate('/agent/download')}
            className="text-sm font-medium text-gray-600 hover:text-gray-900"
          >
            Need to install on another device?
          </button>
        </div>
      </div>
    </div>
  )
}
